import 'zone.js';
import 'bootstrap';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ErrorHandler, importProvidersFrom } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AppComponent } from './app.component';
import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';
import { responseInterceptor } from './interceptors/response.interceptor';
import './styles.css';
import { TranslocoRootModule } from './transloco-root.module';
import { environment } from '@environments/environment';
import { ApiService } from './services/api.service';
import { MockApiService } from './services/mock-api.service';
import { GlobalErrorHandler } from './core/error-handler';
import { LoggerService } from './services/logger.service';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes, withHashLocation()),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([authInterceptor, responseInterceptor])
    ),
    importProvidersFrom(TranslocoRootModule),
    {
      provide: ApiService,
      useClass: environment?.mockApi ? MockApiService : ApiService
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    LoggerService
  ]
}).catch(err => {
  // Use a simple logger for bootstrap errors
  if (typeof console !== 'undefined') {
    console.error('Bootstrap error:', err);
  }
});
